/**
 * Replaces all `\n` and `<div></div>` tags with `<br />` tags and returns the new string
 *
 * Replaces all empty Paragraph tags `<p></p>` with `<br />` tags
 *
 * This method was created for the migration/backwards compatibility of the old news text editor/value to the new RichTextEditor
 * @param stringToSanitize
 * @returns string
 */
export const getHtmlStringWithLineBreaks = (stringToSanitize: string) => {
    let result = "";
    if (stringToSanitize.length > 0) {
        result = stringToSanitize.replace(/<div>|<\/div>|\n/gim, (substring: string) => {
            if (substring === "\n" || substring === "</div>") {
                return "<br />";
            } else {
                return "";
            }
        });
        result = result.replaceAll("<p></p>", "<br />");
    }
    return result;
};
